import repository from './repository';

let EventRepository = repository('/events');

EventRepository.blankEvent = () => {
    return {
        name: '',
        project_id: 0,
    }
};

EventRepository.validate = {
    name: (name) => {
        return (name.length >= process.env.VUE_APP_VALIDATION_EVENT_MIN_EVENT_ID_LENGTH && name.length <= 255);
    },
    project: (p) => {
        return p > 0;
    }
};

export default EventRepository;
